export const setSessionStorageItem = <T>(key: string, value: T) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // Failed to execute 'setItem' on 'Storage': Setting the value of '...' exceeded the quota.
    console.warn(e);
  }
};

export const getSessionStorageItem = <T>(key: string) => {
  let storageValue: T | undefined = undefined;
  try {
    const storedItem = sessionStorage.getItem(key);
    if (storedItem !== null) {
      storageValue = JSON.parse(storedItem);
    }
  } catch (e: unknown) {
    console.warn(e);
  }
  return storageValue;
};

export const clearSessionStorageItem = (key: string) => {
  try {
    sessionStorage.removeItem(key);
  } catch (e: unknown) {
    console.warn(e);
  }
};
